import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "LaunchStudy"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 19.5C17.6642 19.5 18 19.1642 18 18.75C18 18.3358 17.6642 18 17.25 18C16.8358 18 16.5 18.3358 16.5 18.75C16.5 19.1642 16.8358 19.5 17.25 19.5ZM12.75 10.6275L15.4425 7.9425L16.5 9L12 13.5L7.5 9L8.5575 7.9425L11.25 10.6275V1.5H12.75V10.6275ZM21 16.5C21 15.6716 20.3284 15 19.5 15H4.5C3.67157 15 3 15.6716 3 16.5V21C3 21.8284 3.67157 22.5 4.5 22.5H19.5C20.3284 22.5 21 21.8284 21 21V16.5ZM19.5 16.5V21H4.5V16.5H19.5ZM6 18H15V19.5H6V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/LaunchStudy.vue"]]);
